import Person from 'umg-ember-backend/components/record-explorer/for/person';

<template><Person @records={{@model}} @recordType='person' /></template>
